import React from 'react'
import { connect } from 'react-redux'

import { SORT_OPTIONS } from '../../settings'
import { updateSort } from '@bikemap/js/integrations/list'
import { MinimalDropdown } from '@bikemap/components/MinimalDropdown'

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ results }) => {
    const props = {
        options: [],
        value: 0,
    }

    SORT_OPTIONS.forEach((option, i) => {
        let iconAfter
        if (option.key.endsWith('asc')) iconAfter = 'i-arrow-up'
        if (option.key.endsWith('desc')) iconAfter = 'i-arrow-down'
        props.options.push({
            value: i,
            label: iconAfter ? <>{option.name} <i className={iconAfter + ' i-sm text-secondary'} /></> : option.name,
        })

        if (option.sort === results.sort && option.order === results.order) {
            props.value = i
        }
    })

    return props
}

const mapDispatchToProps = dispatch => ({
    onChange: value => {
        const { sort, order } = SORT_OPTIONS[value]
        dispatch(updateSort(sort, order))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(MinimalDropdown)
